<template>
  <div>
    <section id="navbar" v-if="userId">
      <div class="container">
        <div v-for="page in navPages" v-bind:key="page.index">
          <router-link v-bind:to="page.path">
            <span
              v-bind:class="[page.activeIcon, 'active-page']"
              v-if="page.isActive"
            ></span>
            <span
              class="icon-notification-navbar"
              v-if="page.isNotification"
            ></span>
            <span class="navbar-icon" v-bind:class="page.icon"></span>
            <div class="title" v-bind:class="{ bold: page.isActive }">
              {{ page.title }}
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <section id="sidebar" v-if="user">
      <div class="container">
        <div class="sidebar-title">Otti</div>
        <div
          class="link"
          v-for="page in navPages"
          v-bind:key="page.index"
          v-bind:class="{
            'page-active': page.isActive,
            'my-profile': page.path == '/profile',
          }"
        >
          <router-link v-bind:to="page.path">
            <span
              v-bind:class="[page.activeIcon, 'active-page']"
              v-if="page.isActive"
            ></span>
            <span
              class="icon-notification-navbar"
              v-if="page.isNotification"
            ></span>
            <span class="sidebar-icon" v-bind:class="page.icon"></span>
            <div class="title" v-bind:class="{ bold: page.isActive }">
              {{ page.title }}
            </div>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import store from "../../store/store";

import getAllIdeasToEvaluate from "../../gql/ideas/getAllIdeasToEvaluate.gql";

export default {
  data() {
    return {
      userLists: [],
      ideasToEvaluate: [],
      show: false,
      error: null,
    };
  },
  apollo: {
    $subscribe: {
      ideasToEvaluate: {
        query: getAllIdeasToEvaluate,
        variables() {
          return {
            user_id: this.userId,
            list_id_in: this.listIds,
          };
        },
        update: (data) => data.ideas,
        result(data) {
          this.ideasToEvaluate = data.data.ideas;
        },
        error(error) {
          this.error = JSON.stringify(error.message);
        },
      },
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    userId() {
      if (this.user && this.$store.state.user.id) {
        return this.$store.state.user.id;
      } else {
        return null;
      }
    },
    navPages() {
      return this.$store.state.pages;
    },
    userListsStore() {
      return this.$store.state.userLists;
    },
    listIds() {
      let listIds = [];
      for (let i in this.userLists) {
        listIds.push(this.userLists[i].id);
      }
      return listIds;
    },
    ideasToEvaluateFiltered() {
      let ideasToEvaluateFiltered = [];

      for (let i = 0; i < this.ideasToEvaluate.length; i++) {
        if (this.ideasToEvaluate[i].evaluations.length == 0) {
          ideasToEvaluateFiltered.push(this.ideasToEvaluate[i]);
        }
      }
      return ideasToEvaluateFiltered;
    },
    isIdeasToEvaluate() {
      return this.ideasToEvaluateFiltered.length > 0;
    },
  },
  watch: {
    userListsStore: {
      immediate: true,
      handler: function () {
        this.userLists = this.userListsStore;
      },
    },
    isIdeasToEvaluate: {
      immediate: true,
      handler: function () {
        let pages = this.$store.state.pages;
        for (let i in pages) {
          if (pages[i].title == "Evaluate" && this.isIdeasToEvaluate) {
            pages[i].isNotification = true;
          } else {
            pages[i].isNotification = false;
          }
        }
        store.dispatch("fetchPages", pages);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/theme.scss';

#navbar {
  margin-left: - theme.$page-padding-small-X;
  position: fixed;
  z-index: 10;
  bottom: 0px;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.04);
}

#navbar .container {
  margin: 10px 0;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  padding-bottom: env(safe-area-inset-bottom);
}

#navbar .container div {
  margin: auto;
  text-align: center;
}

#navbar .container div a {
  text-decoration: none;
}

#navbar .container div span {
  font-size: 24px;
  color: theme.$primary-color;
}

#navbar .container span.active-page {
  position: absolute;
  color: theme.$secondary-color;
}

#navbar .container span.icon-notification-navbar {
  position: absolute;
}

#navbar .container span.navbar-icon::before {
  color: theme.$primary-color;
}

#navbar .container .title {
  color: theme.$primary-color;
  font-size: 10px;
}

#sidebar {
  position: fixed;
  z-index: 10;
  bottom: 0px;
  top: 0px;
  left: 0px;
  width: 300px;
  height: 100%;
  background-color: theme.$primary-color-dark;
  box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.04);
  display: none;
}

.sidebar-title {
  font-family: theme.$font-family-logo;
  font-weight: theme.$font-weight-black;
  color: theme.$text-white;
  font-size: 26px;
  margin-bottom: 40px;
  padding: theme.$page-padding-X;
  margin-bottom: 10px;
}

#sidebar .container {
  padding: 0;
}

#sidebar .container .title {
  display: inline-block;
  margin-left: 8px;
  vertical-align: text-bottom;
}

.container .link {
  display: block;
  width: 100%;
  color: theme.$text-white;
  padding: 15px theme.$page-padding-X;
  font-size: 16px;
}
#sidebar a {
  color: theme.$text-white;
  text-decoration: none;
}

#sidebar .container div span {
  font-size: 24px;
  color: theme.$text-white;
}

#sidebar .container span.active-page::before {
  position: absolute;
  color: theme.$primary-color;
}

#sidebar .container span.icon-notification-navbar {
  position: absolute;
}

#sidebar .container span.sidebar-icon::before {
  color: theme.$text-white;
}

.container .link.page-active {
  background: rgba(234, 234, 234, 0.2);
}

.container .link.my-profile {
  position: absolute;
  bottom: 15px;
}

@media (min-width: 768px) {
  #sidebar {
    display: block;
  }

  #navbar {
    display: none;
  }
}
</style>